import React from 'react'

import { BaseAddDirectDebitMethodButton } from './BaseAddDirectDebitMethodButton'

export const AddDirectDebitEFT: React.FC = () => {
  return <BaseAddDirectDebitMethodButton i18nKey='addDirectDebitEFT' />
}
